document.addEventListener("DOMContentLoaded", function () {
  const swiperElement = document.querySelector(".swiper-container");
  if (swiperElement) {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      loopFillGroupWithBlank: true,
      direction: "vertical",
      pagination: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        798: {
          // Max-width 990px (below 990px)
          slidesPerView: 3,
        },
        630: {
          slidesPerView: 3,
        },
        991: {
          // Min-width 991px (above 991px)
          slidesPerView: 3,
        },
      },
    });
  }
});
